import { checkStatus } from '../authFunctions';
import ERROR_CODES from '../ErrorCodes';
const identityV3Url = `${window.__ENV__.BFF_URL}/identity/v3/member/token`;

/**
 * Exchange a token and return a partial member JWT
 * @param {Object} idToken - Token to be passed for mli-identity header
 * @param {string} transactionId - transactionId to be passed for mli-session-correlation-id header
 */
export const getPartialJwt = async (idToken, transactionId) => {
  const headers = {
    'Content-Type': 'application/json',
    'mli-session-correlation-id': transactionId,
    'mli-channel': 'web',
    'mli-identity': idToken,
  };
  const method = 'POST';

  try {
    const jwtResponse = await fetch(identityV3Url, {
      method,
      headers,
    }).then(checkStatus);

    const jwtResponseBody = await jwtResponse.json();
    const partialJWT = jwtResponseBody['gb-authorization'];
    return partialJWT;
  } catch (error) {
    throw new Error(ERROR_CODES.GET_PARTIAL_JWT_FAILED);
  }
};
